<template>
  <div>
    <el-divider content-position="left">Serviços</el-divider>
    <el-row :gutter="25">
      <el-col class="col-inavailable" v-if="available.length === 0 && inavailable.length > 0">
        <el-card>
          <div class="header">
            <el-tag type="danger">Serviços Indisponíveis</el-tag>
          </div>
          <el-row :gutter="5" justify="center" v-for="item of inavailable" :key="item.service">
            <el-col :xs="24">
              <img :src="item.image" width="100%" height="60px" class="image"
                :title="item.message || item.description || 'Serviço indisponível para entrega'">
            </el-col>
          </el-row>
        </el-card>
      </el-col>
      <template v-if="available.length > 0">
        <el-col class="card-service" v-for="item of inavailable" :key="'unavail-' + item.service">
          <el-card class="card-service card-unavailable"
            :title="item.message || item.description || 'Serviço indisponível para entrega'">
            <img :src="item.image" width="100%" height="60px" class="image image-unavailable">
            <el-row :gutter="5" justify="center">
              <el-col :xs="24" style="text-align: center; margin-top: 10px">
                <el-tag type="warning" size="small">Serviço Indisponível</el-tag>
              </el-col>
            </el-row>
            <el-row :gutter="5" v-if="item.description" class="card-row-btn">
              <el-col :xs="24" style="text-align: center; padding: 0 8px;">
                <small class="unavailable-desc">{{ item.description }}</small>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </template>
      <el-col class="card-service" v-for="item of available" :key="item.service">
        <el-card class="card-service">
          <img :src="item.image" width="100%" height="60px" class="image">
          <el-row :gutter="5" justify="center">
            <el-col :xs="24" style="text-align: center">
              <el-link @click="selected()" type="success">{{
                item.value
                | currency("R$ ", 2, {
                  thousandsSeparator: ".",
                  decimalSeparator: ",",
                })
              }}</el-link>
            </el-col>
          </el-row>
          <el-row :gutter="5" v-if="item.deadline" class="position: absolute">
            <el-col :xs="24" style="text-align: center" v-if="item.description !== 'offline'">
              <el-tag type="info" style="margin-top: 3px" size="small">Previsão Entrega</el-tag>
              <br />
              <el-tag type="info" style="margin-top: 3px" size="small">
              <b v-if="isJadlogDeadline(item)">
                {{ countJadlogDays(item.deadline.deadline) }}
              </b>
              <b v-else-if="deadlineLabel(item)">
                {{ deadlineLabel(item) }}
              </b>
                <b v-else>{{ item.deadline.deadline }}</b>

                &nbsp;<i class="el-icon-warning-outline" v-if="item.observation"
                :title="item.observation" style="color: #F56C6C"></i>

              </el-tag>
            </el-col>
            <el-col v-else :xs="24" style="text-align: center">
              <el-tag class="two-line-tag" type="info" style="margin-top: 1px" size="small">{{ item.deadline.observation }}</el-tag>
            </el-col>
          </el-row>
          <el-row :gutter="5" class="card-row-btn">
            <el-col :xs="24">
              <el-button type="primary" @click="selected(item)" size="mini" :ref="item.service"
                style="width: 140px">Selecionar</el-button>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { PriceDeadLineService } from "@/services/customers/price.deadline.service";
import { ValuesPrepostService } from "@/services/customers/values.prepost.services";
import { formatDeadlineDays, isJadlogDeadline, countJadlogDays } from "@/utils/shipping-deadline";

export default {
  name: "PdvDeliveryServices",
  props: ["tableData"],
  computed: {
    available() {
      if (this.tableData && this.tableData.length > 0) return this.tableData.filter(x => x.available);
      return [];
    },
    inavailable() {
      if (this.tableData && this.tableData.length > 0) return this.tableData.filter(x => !x.available).sort((a, b) => {
        return a.code.toLowerCase() < b.code.toLowerCase()
          ? -1
          : a.code.toLowerCase() > b.code.toLowerCase()
            ? 1
            : 0;
      });
      return [];
    },
  },
  watch: {
    tableData() {
      //this.check();
    }
  },
  methods: {
    countJadlogDays,
    isJadlogDeadline,
    deadlineLabel(item) {
      return formatDeadlineDays(item, item.deadline);
    },
    check() {
      const vm = this;
      for (const row of vm.tableData.filter((x) => x.check === true)) {
        ValuesPrepostService.check({
          service: row.service,
          sourceZipcode: row.data.source,
          destinyZipcode: row.data.destiny,
        })
          .then((response) => {
            const data = response.data;
            row.available = data.available;
            row.description = "";
            row.forecastAt = data.deadline;
            row.message = response.message;
          })
          .catch((error) => {
            row.available = false;
            row.message = error;
          }).finally(() => row.check = false);
      }
    },
    hotkey(key) {
      const vm = this;
      if (vm.available.length === 0) return false;
      if (!vm.available[key - 1]) return false;
      vm.selected(vm.available[key - 1]);
    },
    formatBRL(value) {
      const num = Number(value) || 0;
      return num.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    selected(item) {
      const formattedValue = this.formatBRL(item.value);
      if (item.shipping) {
        this.$confirm(`Você selecionou um serviço para ${item.name} no valor de ${formattedValue}, deseja confirmar?`, 'Transportadora', {
          distinguishCancelAndClose: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não',
          type: 'warning'
        }).then(() => {
          this.$emit('create', item.service, false, 'request');
        }).catch(() => false)
      } else {
        this.$confirm(`Confirmar a criação da postagem de ${item.name} no valor de ${formattedValue}`, 'Postagem', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }).then(() => {
          this.$emit('create', item.service, false);
        }).catch(() => false)

      }

    },
    focus() { },
    next(el, ev) {
    },
    back() {
      this.$router.replace({
        name: 'pdv',
      })
    }
  }
};
</script>
<style scoped>
.col-inavailable {
  width: 220px;
}

.card-service {
  width: 180px;
  height: 210px;
  position: relative;
}

.card-row-btn {
  position: absolute;
  bottom: 15px;
}

.card-unavailable {
  border-color: #E6A23C;
  background-color: #FDF6EC;
}

.image-unavailable {
  filter: grayscale(100%);
  opacity: 0.6;
}

.unavailable-desc {
  color: #909399;
  font-size: 11px;
  display: block;
  word-break: break-word;
  line-height: 1.3;
}
</style>
